import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "label"];

  connect() {
    this.updateInterestsLabels();
  }

  toggle(event) {
    const checkbox = event.currentTarget.querySelector('input[type="checkbox"]');
    checkbox.checked = !checkbox.checked;
    this.updateInterestLabel(event.currentTarget);
  }

  updateInterestsLabels() {
    this.labelTargets.forEach(label => this.updateInterestLabel(label));
  }

  updateInterestLabel(label) {
    const checkbox = label.querySelector('input[type="checkbox"]');
    if (checkbox.checked) {
      label.classList.add('bg-blue-100', 'border-blue-300');
      label.classList.remove('bg-white', 'border-gray-300');
    } else {
      label.classList.remove('bg-blue-100', 'border-blue-300');
      label.classList.add('bg-white', 'border-gray-300');
    }
  }
}
